{
    "badge__not_released_title": "Not released in ERP yet.",
    "badge__not_released_body": "Click the options menu to release it from within Plato."
}
